import { module as Module } from 'modujs';
import { lazyLoadImage } from '../utils/image';
import LocomotiveScroll from 'locomotive-scroll';
import { $html } from '../utils/dom';

export default class extends Module {
    constructor(m) {
        super(m);

        // Binding
        this.onScrollBind = this.onScroll.bind(this);
    }

    init() {
        this.scroll = new LocomotiveScroll({
            modularInstance: this,
            scrollCallback: this.onScrollBind
        });

        // Force scroll to top
        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual';
            window.scrollTo(0, 0);
        }

        this.scroll.lenisInstance.options.content.addEventListener('wheel', (event) => {
            const targets = event.composedPath();

            const stopPropagation = targets.some((target) => target.id === 'cc-main');
            if (stopPropagation) {
                event.stopPropagation();
            }
        });

        // const hash = window.location.hash
        // if(hash && document.querySelector(hash)) {
        //     this.scrollTo({target: hash, offset: -100})
        // };
    }

    ///////////////
    // Callbacks
    ///////////////
    onScroll({ scroll, velocity, progress }) {
        //get direction
        if (progress > this.lastProgress) {
            if (this.scrollDirection != 1) {
                this.scrollDirection = 1;
                $html.classList.remove('is-scrolling-up');
            }
        } else {
            if (this.scrollDirection != -1) {
                this.scrollDirection = -1;
                $html.classList.add('is-scrolling-up');
            }
        }

        if (this.scrollDirection < 0 && scroll > 300) {
            $html.classList.add('has-header-fixed-visible');
        } else {
            $html.classList.remove('has-header-fixed-visible');
        }

        this.lastProgress = progress;
    }

    /**
     * Lazy load the related image.
     *
     * @see ../utils/image.js
     *
     * It is recommended to wrap your `<img>` into an element with the
     * CSS class name `.c-lazy`. The CSS class name modifier `.-lazy-loaded`
     * will be applied on both the image and the parent wrapper.
     *
     * ```html
     * <div class="c-lazy o-ratio u-4:3">
     *     <img data-scroll data-scroll-call="lazyLoad, Scroll, main" data-src="http://picsum.photos/640/480?v=1" alt="" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" />
     * </div>
     * ```
     *
     * @param {LocomotiveScroll} args - The Locomotive Scroll instance.
     */
    lazyLoad(args) {
        lazyLoadImage(args.target, null, () => {
            //callback
        });
    }

    removeScrollElements($oldContainer) {
        this.scroll?.removeScrollElements($oldContainer);
    }

    addScrollElements($newContainer) {
        this.scroll?.addScrollElements($newContainer);
    }

    scrollTo(params) {
        let { target, options } = params;
        // options = Object.assign({
        //     // Defaults
        //     duration: 1,
        // }, options)

        this.scroll?.scrollTo(target, options);
    }

    resize() {
        this.scroll?.resize();
    }

    destroy() {
        this.scroll.destroy();
    }
}
